import { PublicClientApplication } from '@azure/msal-browser';
import Cookies from 'js-cookie';

let href = window.location.origin;
export const getRedirectUri = () => {
  let redirectUri = '';

  if (href.includes('localhost:3000')) {
    redirectUri = 'http://localhost:3000'; //Backend Fusion )shared)
  } else if (href.includes('192')) {
    redirectUri = window.location.origin;
  } else if (href.includes('localhost:3001')) {
    redirectUri = 'http://localhost:3001'; //Webpack (Wes' Port)
  } else if (href.includes('localhost:3002')) {
    redirectUri = 'http://localhost:3002'; //MikeTec's port
  } else if (href.includes('localhost:3003')) {
    redirectUri = 'http://localhost:3003'; //Brenton's port
  } else if (href.includes('localhost:3004')) {
    redirectUri = 'http://localhost:3004'; //Noah's port
  } else if (href.includes('localhost:3005')) {
    redirectUri = 'http://localhost:3005'; //Joey's port
  } else if (href.includes('localhost:3006')) {
    redirectUri = 'http://localhost:3006'; //Sebastian's port
  } else if (href.includes('localhost:3007')) {
    redirectUri = 'http://localhost:3007'; //Jacob's port
  } else if (href.includes('localhost:3008')) {
    redirectUri = 'http://localhost:3008'; //Charles' port
  } else if (href.includes('devdemo')) {
    redirectUri = 'https://devdemo.overwatch.ai';
  } else if (href.includes('staging')) {
    redirectUri = 'https://stagingdemo.overwatch.ai';
  } else if (href.includes('pittsburgh')) {
    redirectUri = 'https://pittsburghpa.overwatch.ai';
  } else if (href.includes('comal')) {
    redirectUri = 'https://comaltx.overwatch.ai';
  } else if (href.includes('harrison')) {
    redirectUri = 'https://harrisonky.overwatch.ai';
  } else if (href.includes('demo')) {
    redirectUri = 'https://demo.overwatch.ai';
  } else {
    redirectUri = 'https://demo.overwatch.ai';
  }

  return redirectUri;
};

export const configuration = {
  auth: {
    clientId: 'fc3e525d-dc3e-4aaf-a892-ab5d48134bfe',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: getRedirectUri(),
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true,
    },
  },
};

export function SignOut(navigate) {
  Cookies.remove('accesstoken');
  Cookies.remove('refreshtoken');
  Cookies.remove('msToken');
  window.location.href = '/';
}

export const pca = new PublicClientApplication(configuration);

/**
 * MSAL v3.x requires explicit initialization before use.
 * This promise resolves when the instance is ready for authentication calls.
 */
export const msalInitPromise = pca
  .initialize()
  .then(() => {
    // Handle redirect response after initialization
    pca
      .handleRedirectPromise()
      .then((response) => {
        if (response) {
          // Set the account that just signed in as active
          pca.setActiveAccount(response.account);
        }
      })
      .catch((error) => {
        console.error('[MSAL] handleRedirectPromise error:', error);
      });
  })
  .catch((error) => {
    console.error('[MSAL] Initialization failed:', error);
  });
